import { render } from "./editTasks.vue?vue&type=template&id=571715ca&scoped=true&ts=true"
import script from "./editTasks.vue?vue&type=script&lang=ts"
export * from "./editTasks.vue?vue&type=script&lang=ts"

import "./editTasks.vue?vue&type=style&index=0&id=571715ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571715ca"]])

export default __exports__